import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
const PIXEL_ID = '1688179945683486';
export function App() {
  useEffect(() => {
    // Preconnect to critical origins for faster resource loading
    const origins = ['https://cdn.magicpatterns.com', 'https://fonts.gstatic.com'];
    origins.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = href;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
    });
    // Initialize Meta Pixel via script injection (deferred)
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Defer pixel loading to after initial render
    const loadPixel = () => {
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 3000);
    }
    f.fbq('init', PIXEL_ID);
    f.fbq('track', 'PageView');
  }, []);
  return <SalesPage data-id="element-0" />;
}